var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 10.0835C16.1883 10.0835 17.4075 8.85516 17.4075 7.3335C17.4075 5.81183 16.1883 4.5835 14.6666 4.5835C13.145 4.5835 11.9166 5.81183 11.9166 7.3335C11.9166 8.85516 13.145 10.0835 14.6666 10.0835ZM7.33329 10.0835C8.85496 10.0835 10.0741 8.85516 10.0741 7.3335C10.0741 5.81183 8.85496 4.5835 7.33329 4.5835C5.81163 4.5835 4.58329 5.81183 4.58329 7.3335C4.58329 8.85516 5.81163 10.0835 7.33329 10.0835ZM7.33329 11.9168C5.19746 11.9168 0.916626 12.9893 0.916626 15.1252V16.5002C0.916626 17.0043 1.32913 17.4168 1.83329 17.4168H12.8333C13.3375 17.4168 13.75 17.0043 13.75 16.5002V15.1252C13.75 12.9893 9.46913 11.9168 7.33329 11.9168ZM14.6666 11.9168C14.4008 11.9168 14.0983 11.9352 13.7775 11.9627C13.7958 11.9718 13.805 11.9902 13.8141 11.9993C14.8591 12.7602 15.5833 13.7777 15.5833 15.1252V16.5002C15.5833 16.821 15.5191 17.1327 15.4183 17.4168H20.1666C20.6708 17.4168 21.0833 17.0043 21.0833 16.5002V15.1252C21.0833 12.9893 16.8025 11.9168 14.6666 11.9168Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/TeamIcon.dc3c2341285f08ea405d5157a10d7ba4.svg";
export { ForwardRef as ReactComponent };